exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar .navbar-nav>.navbar-chat>#commentchat{padding:10px;margin:10px 3px;position:relative}.navbar .navbar-nav>.navbar-chat>#commentchat-mobile{padding:5px 10px 10px;margin:10px 3px;position:relative}.el-badge__content{line-height:14px!important;border-color:transparent!important}", ""]);

// exports
